import { OrderItem } from '~types/appsync.types';

export const formatPrice = (
  locale: string,
  currency: string,
  price: number,
  maximumFractionDigits?: number,
) => {
  return Intl.NumberFormat(locale, { currency, maximumFractionDigits, style: 'currency' }).format(
    price,
  );
};

export const getTotalPriceWithOptions = (orderItem: OrderItem) => {
  return orderItem.children.reduce((acc, child) => acc + child.total, orderItem.total);
};
